import { useState, useCallback } from 'react';
import { message } from 'antd';
import { p9311Api, QueryParams, QueryResponse } from '../../../services/p9311Api';

export interface P9311QueryState {
  loading: boolean;
  result: QueryResponse | null;
  queried: boolean;
  noData: boolean;
}

export interface P9311QueryActions {
  runQuery: (params: QueryParams) => Promise<void>;
  reset: () => void;
}

export function useP9311Query(): P9311QueryState & P9311QueryActions {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<QueryResponse | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await p9311Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setResult(resp);
        setNoData(false);
      } else {
        setResult(null);
        setNoData(true);
        message.info('查無符合條件的出勤資料');
      }
      setQueried(true);
    } catch (err: unknown) {
      const axErr = err as { response?: { status?: number; data?: { errors?: string[] } } };
      if (axErr.response?.status === 422 && axErr.response?.data?.errors) {
        message.error(axErr.response.data.errors.join('\n'));
      } else {
        message.error('查詢失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, result, queried, noData, runQuery, reset };
}
